export default __webpack_public_path__ + "static/media/008-circle-orange.ddd57ff3.svg";